import React from "react";
import {observer} from "mobx-react-lite";
import GameStore from "../../store/game";

// Панель найденных слов для режима свободного поиска.
const WordTargetsPanel = observer(() => {
    const foundCount = Array.isArray(GameStore.foundWords) ? GameStore.foundWords.length : 0;
    const lastWords = Array.isArray(GameStore.foundWords) ? GameStore.foundWords.slice(-8).reverse() : [];

    return (
        <div className="px-4">
            <div className="bg-gray-100 rounded-xl px-4 py-3 flex flex-col gap-3">
                <div className="flex items-center justify-between">
                    <div className="text-sm text-gray-700">Слова</div>
                    <div className="text-sm font-semibold text-gray-900">
                        Найдено: {foundCount}
                    </div>
                </div>

                <div className="rounded-lg border border-gray-300 bg-gray-300/40 px-2.5 py-2">
                    <div className="text-[11px] text-gray-400 mb-1">
                        Последние находки
                    </div>
                    <div className="flex flex-wrap gap-1">
                        {lastWords.length === 0 ? (
                            <span className="text-xs text-gray-600">Пока нет найденных слов</span>
                        ) : lastWords.map((word, index) => (
                            <span
                                key={`word-${word}-${index}`}
                                className="px-2 py-0.5 rounded-full text-xs bg-gray-300 text-gray-700"
                            >
                                {word}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default WordTargetsPanel;
